module.exports = __webpack_public_path__ + "img/icon44.3ca1bf9c.png";